export default __webpack_public_path__ + "static/media/SEC-2.d6f563e8.jpg";